/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./frame-img-list.vue?vue&type=template&id=4484a5be&scoped=true&"
import script from "./frame-img-list.vue?vue&type=script&lang=ts&"
export * from "./frame-img-list.vue?vue&type=script&lang=ts&"
import style0 from "./frame-img-list.vue?vue&type=style&index=0&id=4484a5be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4484a5be",
  null
  
)

export default component.exports